import axios from "axios";
import React, { createContext, useEffect, useState } from "react";

export const inMemoriamContext = createContext([]);

export default function InMemoriamContext({ children }) {
  const [inMemoriamData, setInMemoriamData] = useState(null);
  const [loading, setLoading] = useState(false);

  const getInMemoriamData = async () => {
    try {
      const result = await axios.get(
        `https://api.alachuacounty.us/truth-rec-backend/api/getInMemoriamfilter`
      );
      return result;
    } catch (error) {
      console.log({ error });
      setLoading(false);
      return [];
    }
  };

  const initialLoad = async () => {
    const result = await getInMemoriamData();

    setInMemoriamData(result.data);
    setLoading(true);
 /*    console.log("In Memoriam context load:: ");
    console.log(result.data); */
  };

  useEffect(() => {
    initialLoad();
  }, []);

  return (
    <inMemoriamContext.Provider value={{ inMemoriamData, loading }}>
      {children}
    </inMemoriamContext.Provider>
  );
}
